import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem'
  },

  name: {
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    color: '#323436',
    cursor: 'default'
  },

  remove: {
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    color: 'red',
    marginLeft: '2rem',
    cursor: 'pointer'
  },

  participants: {
    margin: '0 1rem',

    '& .MuiBadge-dot': {
      zIndex: '0'
    }
  }
}))

export default useStyles
